import CalendarEdit from './calendar-edit';

export default CalendarEdit;
